export default "__VITE_ASSET__DxZJyVgn__"